var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecentProjectsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Recent_Projects-Icon",
    transform: "translate(-401 -507.804)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_334",
    "data-name": "Rectangle 334",
    width: 40,
    height: 40,
    rx: 8,
    transform: "translate(401 507.804)",
    fill: "#211f21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M5.679,8.4,2.25,10.25,5.679,12.1m0-3.692,4.571,2.462L14.821,8.4m-9.142,0L2.25,6.558l8-4.308,8,4.308L14.821,8.4m0,0L18.25,10.25,14.821,12.1m0,0,3.429,1.846-8,4.308-8-4.308L5.679,12.1m9.142,0L10.25,14.558,5.679,12.1",
    transform: "translate(410.691 517.691)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentProjectsIcon);
export default __webpack_public_path__ + "static/media/Recent_Projects-Icon.5cbdd717a4aec008a0ac00c2db790bd1.svg";
export { ForwardRef as ReactComponent };